import { baseURL, clientBase } from '@/api/httpAxios'
import { URLs, Contacts, systemNames } from '@it/orpk-vue-ts'

export const productionURL = URLs.productionURL
export const devProductionURL = URLs.devProductionURL

export const supportEmail = Contacts.supportEmail
export const wikiURL =
  'https://digital.etu.ru/doku.php?id=navigation:attendance'

export const wikiPage = Contacts.wikiPage

export const lkETUName = systemNames.lk.auth

export const isDev = import.meta.env.DEV
export const isProduction = !isDev

export const authBase = `${baseURL}/auth`
export const authDevBase = `${baseURL}/auth/dev`

export const clientBaseWithSlash = clientBase + '/'

export const vueDevToolsURL = URLs.vueDevToolsURL

export const vibeLabSupport = 'support@vibelab.ru'
